module.exports = __webpack_public_path__ + "img/flat collar length.dc4f74dc.png";